// Copyright (c) Facebook, Inc. and its affiliates.
import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid'
import Button from '@material-ui/core/Button'
import Link from '@material-ui/core/Link';
import Divider from '@material-ui/core/Divider';

import Banner from './Banner';
import People from './People';
import CustomDivider from './CustomDivider';
import ImageList from './ImageList';
import DatasetFeature from './DatasetFeature';
import * as config from '../frontend_config.json';
import { ReactiveBase } from '@appbaseio/reactivesearch';


const styles = theme => ({
    paper: {
        ...theme.mixins.gutters(),
        paddingTop: theme.spacing.unit * 2,
        paddingBottom: theme.spacing.unit * 2,
    },
    button: {
        backgroundColor: theme.palette.primary.main,
        color: '#fff',
        fontWeight: '700',
        fontSize: '0.85rem',
        borderRadius: '10rem',
        'textTransform': 'uppercase',
        padding: '1.25rem 2.25rem',
        margin: '2rem'
    },
    mainContainer: {
        opacity: 0.9,
        height: '100vh',
        [theme.breakpoints.down('sm')]: {
            height: '60vh',
            paddingTop: '5rem'
        },
    },
    backgroundImage: {
        height: '100vh',
        width: '100%',
        position: "absolute",
        backgroundImage: 'linear-gradient(to bottom,rgba(92,77,66,.8) 0,rgba(92,77,66,.8) 100%),url("assets/images/bg.jpg")',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        [theme.breakpoints.down('sm')]: {
            height: '60vh',
        },
    },
    gridContainer: {
        margin: '0 auto',
        padding: '4rem'
    },
    paddingTop: {
        paddingTop: '4rem'
    },
    root: {
        // flexGrow: 1,
        // marginTop: '50px'
    },
    divider: {
        color: '#888',
        width: '100%'
    },
    gridItem: {
        padding: theme.spacing.unit * 1.5
    },
    sectionHeader: {
        marginTop: '0.2em',
        fontSize: '2.5g rem',
    },
    mastHeading: {
        marginTop: '0.2em',
        color: '#fff',
        fontWeight: '700',
        fontSize: '3.35rem',
        lineHeight: '1.25',
        [theme.breakpoints.down('sm')]: {
            marginTop: '0.5rem',
            fontWeight: '400',
            fontSize: '1.55rem',
            lineHeight: '1.5',
        },
    },
    mastText: {
        marginTop: '0.8em',
        color: '#c7beb7',
        fontWeight: '300',
        fontSize: '1.25em',
        [theme.breakpoints.down('sm')]: {
            fontWeight: '300',
            fontSize: '1rem',
        },
    },
    ulList: {
        margin: '0'
    },
    container: {
        padding: theme.spacing.unit * 2,
    },
    bannerLogo: {
        width: '100%'
    },
    spanInlineBlock: {
        display: 'inline'
    },
    primaryColor: {
        color: theme.palette.primary.main
    },
    preParent: {
        backgroundColor: '#eee',
        border: '1px solid #ddd',
        borderRadius: '2px',
        '& pre': {
            whiteSpace: 'pre-wrap',
        },
        '& span': {
            padding: '1em',
        },
        '& code': {
            fontSize: '12px',
            color: '#000'
        }
    },
    codeGrid: {
        padding: theme.spacing.unit * 1.5,
        backgroundColor: '#eee'
    },
    codeFont: {
        whiteSpace: 'pre-wrap',
        fontFamily: 'SF Mono, monospace',
    },
});

class Home extends React.Component {

    render() {
        const { classes } = this.props;

        return (
            <div className={classes.root}>
                <Grid
                    container
                    className={classes.mainContainer}
                    direction="row"
                    justify="center"
                    alignItems="center"
                >
                    <div className={classes.backgroundImage}
                    />
                    <Grid
                        style={{
                            zIndex: '100'
                        }}
                        item xs={12} lg={6} className={classes.gridItem}>
                        <Typography
                            className={classes.mastHeading}
                            variant="h1"
                            align="center"
                        >
                            LVIS: A DATASET FOR LARGE VOCABULARY INSTANCE SEGMENTATION
                        </Typography>
                        <CustomDivider lgSize={4}/>
                        <Typography
                            className={classes.mastText}
                            variant="subtitle1"
                            align="center"
                        >
                            A new dataset for long tail object recognition.
                        </Typography>
                        <Link href="https://arxiv.org/abs/1908.03195">
                            <Button variant="contained" disableRipple={true} disableFocusRipple={true}  className={classes.button}>
                                Paper
                            </Button>
                        </Link>
                    </Grid>
                </Grid>

                <Grid
                    container
                    justify="center"
                    alignContent="center"
                    className={classes.paddingTop}
                >
                    <Grid item xs={10}>
                        <div>
                            <DatasetFeature/>
                        </div>

                        <div className={classes.paddingTop}>
                            <ImageList />
                        </div>

                        {/* <div className={classes.paddingTop}>
                            <Grid container justify="flex-start" spacing={16}>
                                <Grid item xs={12} className={classes.gridItem}>
                                    <Typography
                                        className={classes.sectionHeader}
                                        variant="h4"
                                        align="center"
                                    >
                                        LVIS Challenge at ICCV 2019
                                    </Typography>
                                    <CustomDivider />
                                </Grid>
                            </Grid>
                            <Grid container justify="center" spacing={16}>
                                <Grid item xs={12} className={classes.gridItem}>
                                    <Typography
                                        className={classes.sectionHeader}
                                        variant="subtitle1"
                                        align="center"
                                    >
                                        First LVIS challenge will be held at
                                        <Link href="http://cocodataset.org/workshop/coco-mapillary-iccv-2019.html"> Joint COCO and Mapillary
                                        Recognition Challenge Workshop</Link>.
                                    </Typography>
                                </Grid>
                            </Grid>
                        </div> */}

                        <div className={classes.paddingTop}>
                            <Grid container justify="flex-start" spacing={16}>
                                <Grid item xs={12} className={classes.gridItem}>
                                    <Typography
                                        className={classes.sectionHeader}
                                        variant="h4"
                                        align="center"
                                    >
                                        People
                                    </Typography>
                                    <CustomDivider />
                                </Grid>
                            </Grid>

                            <People/>
                        </div>

                        <div className={classes.paddingTop}>
                            <Grid container spacing={16}>
                                <Grid item xs={12} className={classes.gridItem}>
                                    <Typography
                                        className={classes.sectionHeader}
                                        variant="h4"
                                        align="center"
                                    >
                                        Citing LVIS
                                    </Typography>
                                    <CustomDivider />
                                </Grid>

                                <Grid item xs={12} className={classes.codeGrid}>
                                    <pre>
                                    <Typography component="span" align="left">
                                        <Typography component="pre">
                                            <Typography component="span" variant="body2">
<code className={classes.codeFont}>
{`@inproceedings{gupta2019lvis,
  title={{LVIS}: A Dataset for Large Vocabulary Instance Segmentation},
  author={Gupta, Agrim and Dollar, Piotr and Girshick, Ross},
  booktitle={Proceedings of the {IEEE} Conference on Computer Vision and Pattern Recognition},
  year={2019}
}`}</code>

                                            </Typography>
                                        </Typography>
                                    </Typography>
                                </pre>
                                </Grid>
                            </Grid>
                        </div>


                        <div className={classes.paddingTop}>
                            <Grid container justify="flex-center" spacing={16}>
                                <Grid item xs={12} className={classes.gridItem}>
                                    <Typography
                                        className={classes.sectionHeader}
                                        variant="h4"
                                        align="center"
                                    >
                                        Acknowledgments
                                    </Typography>
                                    <CustomDivider />
                                </Grid>
                                <Grid item xs={12} className={classes.gridItem}>
                                    <Typography
                                        variant="subtitle1"
                                        align="left"
                                    >
                                        We thank Ilija Radosavovic, Amanpreet Singh, Alexander Kirillov, and Tsung-Yi Lin for their
                                        help during the creation of LVIS. We would also like to thank COCO Committee for giving us
                                        the permission to annotate the COCO test set. We are grateful to Amanpreet Singh for his help in
                                        creating the LVIS website.
                                    </Typography>
                                </Grid>
                            </Grid>
                        </div>

                        <div className={classes.paddingTop}>
                            <Grid container justify="flex-start" spacing={16}>
                                <Grid item xs={12} className={classes.gridItem}>
                                    <Typography
                                        className={classes.sectionHeader}
                                        variant="h4"
                                        align="center"
                                    >
                                        Contact
                                    </Typography>
                                    <CustomDivider />
                                </Grid>
                                <Grid item xs={12} className={classes.gridItem}>
                                    <Typography
                                        variant="subtitle1"
                                        align="center"
                                    >
                                        Questions? Please check our <Link href="https://groups.google.com/forum/#!forum/lvis-dataset">user forum</Link>.
                                        If you cannot find answer there, reach us at <Link href="mailto:lvis-dataset@googlegroups.com">lvis-dataset@googlegroups.com</Link> for any questions, suggestions and feedback.
                                    </Typography>
                                </Grid>
                            </Grid>
                        </div>

                    </Grid>
                </Grid>
            </div>
        );
    }
}

export default withStyles(styles)(Home);
